import React from "react";
import {
  Status,
  Protocol,
  //  ErrorTypes
} from "./lib/constants";
import { MessageFactory } from "./lib/messages";
import GameUtils from "./lib/gameutils";
import { MessagesList } from "./lib/spheres_msg";
import { WS } from "./lib/websocket";

import { AppContainer } from "./AppStyled";
import Spheres from "./components/spheres/Spheres";

import AutoRollLogic from "./components/otherPages/auto/AutoLogic";
import { NoSignal } from "./components/otherPages/noSignal/NoSignal";
import Notification from "./components/otherPages/notifications/Notification";
import { logger } from "./lib/logger.js";
export let Globals = {};
class App extends React.Component {
  constructor(props) {
    super(props);

    this.WS_URL = "{{SERVER_WS_URL}}";
    this.hostname = window.location.hostname
    if (this.hostname === 'localhost') {
      this.WS_URL = 'wss://arch.orbitalgaming.io/wsbrdige/v1/orbital.spheres'
    } else if (this.WS_URL.includes('SERVER_WS_URL')) {
      this.WS_URL = `wss://${this.hostname}/wsbridge/v1/game/orbital.spheres`
    }


    this.state = {
      user_id: null,
      isFast: false,

      noSignal: false,
      errorMsg: "",
      errorBtn: "",
      reload: false,

      notification: false,
      notificationfadeOut: false,

      bet: null,
      toFix: 4,
      maxBet: 100,
      minBet: 0.1,
      currency: "",
      isClickable: false,
      showText: true,
      betInfo: {
        balance: null,
        dealer: [],
        winTypeDealer: null,
        winPositionsDealer: [],
        player: [],
        winTypePlayer: null,
        winPositionsPlayer: [],
        winAmount: null,
        winCoeff: 1,
        betAmount: null,
        currency: "",
      },

      isAutoOn: false,
      stats: {
        all_stats: [],
        my_stats: [],
        big_stats: [],
      },

      myHistory: [],
      allHistory: [],
      highRoller: [],

      autoConfigs: {
        numberOfBets: "0",
        onWinReset: "1",
        onWinPercent: "0",
        onLossReset: "1",
        onLossPercent: "0",
        stopOnProfit: "0",
        stopOnLoss: "0",
      },
      userSettings: {
        music: false,
        sound: false,
        volume: 0.2,
      },
      provablyFairSeeds: {
        client_seed: "",
        server_seed_SHA256: "",
        nonce: null,
        old_client_seed: "",
        old_server_seed: "",
        old_server_seed_SHA256: "",
        old_nonce: null,
      },
      betReplay: {},
    };

    this.myHistoryLocal = [];
    this.historyLocal = [];
    this.highRollerLocal = [];
    this.autorollLogic = new AutoRollLogic();
    this.myTimeout = null;
    this.notificationTimeOut = null;

    // Globals = {};
    this.doMessage = this.doMessage.bind(this);
    this.setStatus = this.setStatus.bind(this);
  }
  componentDidMount() {
    console.log('%cV2.0.2 DG', 'background: green; font-size: 16px')
    window._mfq = window._mfq || [];
    (function () {
      var mf = document.createElement("script");
      mf.type = "text/javascript";
      mf.defer = true;
      mf.src =
        "https://cdn.mouseflow.com/projects/27d3415e-736e-4ff5-9a5c-1aa7729b351d.js";
      document.getElementsByTagName("head")[0].appendChild(mf);
    })();
    MessageFactory.messagesList = MessagesList;
    Globals.WS = new WS()
      .Init({
        WS_URL: this.WS_URL,
        doMessage: this.doMessage,
        setStatus: this.setStatus,
      })
      .Start();
    // experiment
  }
  componentWillUnmount() {
    Globals.WS.Disconnect();
    this.setState({ noSignal: true });
  }

  setStatus(status) {
    logger.log("%cstatus = ", "color:brown", status);
    switch (status) {
      case Status.CONNECTED:
        logger.log("%cconnected ", "color:green");
        // this.setState({ noSignal: false });
        this.setState({ noSignal: false, reload: false });

        const session = GameUtils.getParameterByName("session");
        if (typeof session == "string") {
          const loginMsg = MessageFactory.createMessage(
            Protocol.LOGIN,
            GameUtils.getParameterByName("session") + "@1",
          );
          Globals.WS.sendMessage(loginMsg);
        } else {
          // TODO : not logged in`
          logger.log("not logged in" + status);
        }

        break;
      case Status.DISCONNECTED:
        logger.log("%cdisconnected ", "color:brown");
        // this.setState({
        //   popup: true,
        //   isAutoOn: false,
        //   noSignal: true,
        //   // notifyMSG: false,
        // });

        this.setState({
          // popup: true,
          noSignal: true,
          notification: false,
          above: false,
          errorMsg: `Your session has expired, please reload the page to continue`,
          reload: true,
          errorBtn: false,
        });

        clearTimeout(this.myTimeout);
        clearTimeout(this.notificationTimeOut);
        break;
      default:
        break;
    }
  }
  doMessage(msg) {
    var msgObject = null;
    try {
      msgObject = MessageFactory.parseMessage(msg);
    } catch (e) {
      console.dir(e);
    }
    if (msgObject === null) {
      //error unknown message
      logger.log("doMessage msgObject === null ", msg);
      return;
    }

    switch (msgObject.type) {
      case Protocol.BET_INFO:
        logger.log("%cBET_INFO", "color:aqua", msgObject);

        this.setState({ betInfo: msgObject, bet: msgObject.betAmount });
        // this.props.handleBetInfo(msgObject); // dzaan ar momwons TODO
        let { autorollLogic, handleNotification } = this;
        const setState = this.setState.bind(this);
        const handleShowText = this.handleShowText.bind(this);
        const clearBetInfo = this.clearBetInfo.bind(this);
        const { isAutoOn, isFast, maxBet, toFix, currency } = this.state; //  es wina xo araa ??? state ki ara msgObject unda daishalos
        const { winAmount, betAmount, balance } = msgObject;

        let time = isFast ? 1200 : 5000;
        if (isAutoOn) {
          this.myTimeout = setTimeout(function () {
            let value = autorollLogic.nextStep(winAmount - betAmount);
            if (+autorollLogic.bet > maxBet) {
              handleNotification("Max bet limit is " + maxBet);
              setState({
                isAutoOn: false,
              });
              return;
            }

            if (+autorollLogic.bet > balance) {
              handleNotification("Not enough balance");

              setState({
                isAutoOn: false,
              });
              return;
            }
            switch (value) {
              case AutoRollLogic.ROLL_OK:
                handleShowText(false);
                clearBetInfo();

                Globals.WS.sendMessage(
                  MessageFactory.createMessage(
                    Protocol.BET,
                    +autorollLogic.bet,
                  ),
                );
                break;
              case AutoRollLogic.ROLL_STOP_ON_LOSS:
                handleNotification(
                  `Stopped on loss - ${(+autorollLogic.ggr).toFixed(toFix)} ` +
                  currency,
                );

                setState({
                  isAutoOn: false,
                });
                break;
              case AutoRollLogic.ROLL_STOP_ON_WIN:
                handleNotification(
                  `Stopped on  win - ${(+autorollLogic.ggr).toFixed(
                    toFix,
                  )} ${currency}`,
                );

                setState({
                  isAutoOn: false,
                });
                break;
              case AutoRollLogic.ROLL_STOP_ON_NUMBETS:
                handleNotification("Stopped on a selected number of bets");
                setState({
                  isAutoOn: false,
                });
                break;

              default:
                break;
            }
          }, time);
        }

        break;
      case Protocol.BET_INFO_ALL:
        logger.log("%cBET_INFO_ALL", "color:aqua", msgObject);
        break;
      case Protocol.HISTORY:
        let timeHistory = 0;
        if (this.state.isAutoOn) {
          timeHistory = this.state.isFast ? 1200 : 5000;
        }
        //
        setTimeout(() => {
          this.historyLocal.unshift(msgObject);
          while (this.historyLocal.length > 18) {
            this.historyLocal.pop();
          }
          if (msgObject.user_id === this.state.user_id) {
            this.myHistoryLocal.unshift(msgObject);
            while (this.myHistoryLocal.length > 18) {
              this.myHistoryLocal.pop();
            }
          }
          if (msgObject.bigWin === 2) {
            this.highRollerLocal.unshift(msgObject);
            while (this.highRollerLocal.length > 18) {
              this.highRollerLocal.pop();
            }
          }
          this.setState({
            allHistory: this.historyLocal,
            myHistory: this.myHistoryLocal,
            highRoller: this.highRollerLocal,
          });
        }, timeHistory);

        break;
      case Protocol.GAME_STATE:
        logger.log("%cGAME_STATE", "color:aqua", msgObject);

        let betInf = this.state.betInfo;
        betInf.balance = msgObject.balance;
        this.setState({
          isClickable: true,
          betInfo: betInf,
          user_id: msgObject.user_id,
          toFix: msgObject.afterDot,
          minBet: msgObject.minBet,
          maxBet: msgObject.maxBet,
          currency: msgObject.currency,
          provablyFairSeeds: {
            server_seed_SHA256: msgObject.server_seed_SHA256,
            client_seed: msgObject.client_seed,
            nonce: msgObject.nonce,
          },
        });
        break;
      case Protocol.USER_SETTINGS_RESPONCE:
        let min = this.state.minBet;
        let max = this.state.maxBet;
        if (msgObject.settings === "") {
          logger.log("USER_SETTINGS_RESPONCE is empty ");
        }
        if (msgObject.settings.split(";").length !== 11) {
          msgObject.settings = `true;true;0.5;0;0;0;0;0;0.00;0.00;${min}`;
          const settings = MessageFactory.createMessage(
            Protocol.USER_SETTINGS,
            msgObject.settings,
          );
          Globals.WS.sendMessage(settings);
        }
        let arr = msgObject.settings.split(";");
        if (+arr[10] < min) {
          arr[10] = min;
          msgObject.settings = `40;true;true;0.5;0;0;0;0;0;0;0;${min}`;
          const settings = MessageFactory.createMessage(
            Protocol.USER_SETTINGS,
            msgObject.settings,
          );
          Globals.WS.sendMessage(settings);
        }
        if (+arr[10] > max) {
          arr[10] = min;
          msgObject.settings = `40;true;true;0.5;0;0;0;0;0;0;0;${min}`;
          const settings = MessageFactory.createMessage(
            Protocol.USER_SETTINGS,
            msgObject.settings,
          );
          Globals.WS.sendMessage(settings);
        }
        this.setState({
          bet: arr[10],
          userSettings: {
            music: arr[0] === "true",
            sound: arr[1] === "true",
            volume: arr[2] > 1 ? 1 : +arr[2],
          },
          autoConfigs: {
            numberOfBets: arr[3],
            onWinReset: arr[4],
            onWinPercent: arr[5],
            onLossReset: arr[6],
            onLossPercent: arr[7],
            stopOnProfit: arr[8],
            stopOnLoss: arr[9],
          },
        });
        break;

      case Protocol.GET_ROUND_RESPONCE:
        logger.log("%cGET_ROUND_RESPONCE", "color:aqua", msgObject);
        // this.props.handleBetReplay(msgObject);
        // this.setState({ betReplay: msgObject });
        this.handleBetReply(msgObject);
        break;
      case Protocol.GET_STATS_RESPONCE:
        logger.log("%cGET_STATS_RESPONCE", "color:aqua", msgObject);
        this.setState({ stats: msgObject });
        // this.props.addInStatsForChart(msgObject);
        break;
      case Protocol.GET_SEEDS_RESPONCE:
        logger.log("GET_SEEDS_RESPONCE", msgObject);
        this.setState({ provablyFairSeeds: msgObject });
        break;

      case Protocol.ERROR:
        // logger.log(msgObject, "ERRROOOOR");
        console.error("doMessage error read " + msgObject.errorCode);
        switch (msgObject.errorCode) {
          case 1:
            console.error("CONCURRENT_CONNECTION");
            this.setState({
              errorMsg:
                "Your session has expired, please reload the page to continue",
              errorBtn: "Reload",
              noSignal: true,
              reload: true,
            });
            break;
          case 2:
            console.error("INVALID_SESSION");
            this.setState({
              errorMsg:
                "Your session has expired, please reload the page to continue",
              errorBtn: false,
              noSignal: true,
              reload: true,
            });
            break;
          case 3:
            console.error("INSUFFICIENT_FUNDS", msgObject);
            this.handleNotification("Not enough balance");
            this.handleIsClickable(true);
            this.handleShowText(true);
            this.setState({ isClickable: true });
            if (this.state.isAutoOn) {
              this.toggleIsAutoOn(false)
            }
            break;
          case 4:
            console.error("INVALID_BET_AMOUNT", msgObject);
            this.handleNotification("Invalid bet amount");
            this.handleShowText(true);
            this.setState({
              isDisabled: false,
              gameIsOn: false,
              inactiveGame: true,
            });
            this.handleIsClickable(true);
            setTimeout(() => {
              this.setState({ inactiveGame: false });
            }, 167);
            if (this.state.isAutoOn) {
              this.toggleIsAutoOn(false)
            }
            break;
          case 5:
            console.error("MONEY_TRANSFER_ERROR", msgObject);
            this.setState({
              errorMsg: "Something went wrong, reload the page if necessary",
              errorBtn: "Reload",
              noSignal: true,
              reload: true,
            });
            if (this.state.isAutoOn) {
              this.toggleIsAutoOn(false)
            }
            break;
          case 6:
            console.error("INVALID_BET", msgObject);
            this.handleNotification("Invalid bet amount");
            this.handleIsClickable(true);
            this.handleShowText(true);
            this.setState({ isDisabled: false, gameIsOn: false });
            if (this.state.isAutoOn) {
              this.toggleIsAutoOn(false)
            }
            break;
          case 7:
            console.error("PF_NOT_SET", msgObject);
            this.setState({
              errorMsg: "Provably fair seed is not set",
              errorBtn: "Reconnect",
              noSignal: true,
              reload: false,
            });
            break;
          case 8:
            console.error("CLIENT_SEED_ERROR", msgObject);
            break;
          case 9:
            console.error("CLIENT_SEED_OK", msgObject);
            this.handleNotification("Provably fair seed set successfully");
            break;
          case 10:
            console.error("SYSTEM_ERROR", msgObject);
            this.setState({
              errorMsg: "Something Went Wrong, reload the page if necessary",
              errorBtn: false,
              noSignal: true,
              reload: false,
            });
            break;
          case 11:
            console.error("INVALID_ACTION", msgObject);
            this.handleNotification("Invalid action");
            this.handleIsClickable(true);
            this.handleShowText(true);
            if (this.state.isAutoOn) {
              this.toggleIsAutoOn(false)
            }
            this.setState({ isDisabled: false, inactiveGame: true });
            setTimeout(() => {
              this.setState({ inactiveGame: false });
            }, 167);
            break;
          case 13:
            console.error("NOT_FOUND", msgObject);
            break;
          case 14:
            console.error("GAME_NOT_ACTIVE", msgObject);
            this.setState({
              errorMsg: "Game is not active, reload the page if necessary",
              errorBtn: false,
              noSignal: true,
            });

            break;
          case 16:
            console.error("INSUFFICIENT_FUNDS", msgObject);
            this.handleNotification("Not enough balance");
            this.handleIsClickable(true);
            this.handleShowText(true);
            this.setState({ isClickable: true });
            if (this.state.isAutoOn) {
              this.toggleIsAutoOn(false)
            }
            break;
          case 115:
            console.error("MAX_BET_LIMIT", msgObject);
            this.handleNotification("You have exceeded your betting limit");
            this.handleIsClickable(true);
            this.handleShowText(true);
            this.setState({ isDisabled: false, gameIsOn: false });
            if (this.state.isAutoOn) {
              this.toggleIsAutoOn(false)
            }
            break;
          default:
            console.error("SOMETHING WENT WRONG", msgObject);
            this.setState({
              errorMsg: "Something went wrong, reload the page if necessary",
              errorBtn: false,
              noSignal: true,
            });
            break;
        }
        break;
      default:
        logger.log("default", msgObject);
        break;
    }
  }

  handleAutoRollLogic = (e) => {
    this.autorollLogic.setSettings(...e);
    this.setState({ isAutoOn: true, isClickable: false });
    this.saveAutoConfigs([e[8], e[4], e[5], e[2], e[3], e[7], e[6]], e[0]);
    this.clearBetInfo();
    this.handlePlay(e[0]);
  };
  handleBetAmount = (b) => this.setState({ bet: b });
  handleBetReply = (obj) => this.setState({ betReplay: obj });

  saveUserSettings = (userSettings) => {
    const { autoConfigs, bet } = this.state;
    const sets = Object.values(userSettings);
    const auto = Object.values(autoConfigs);
    const str = sets.concat(auto, bet);
    const j = str.join(";");
    this.setState({
      userSettings: {
        music: userSettings[0],
        sound: userSettings[1],
        volume: userSettings[2],
      },
    });
    const settings = MessageFactory.createMessage(Protocol.USER_SETTINGS, j);
    Globals.WS.sendMessage(settings);
  };
  saveAutoConfigs = (autoConfigs, bet) => {
    const { userSettings } = this.state;
    const sets = Object.values(userSettings);
    const str = sets.concat(autoConfigs, bet);
    const j = str.join(";");
    const settings = MessageFactory.createMessage(Protocol.USER_SETTINGS, j);
    Globals.WS.sendMessage(settings);
  };
  saveBetAndPlay = (b) => {
    this.clearBetInfo();
    const {
      autoConfigs,
      userSettings,
      betInfo: { betAmount, balance },
    } = this.state;
    if (+balance >= +b) {
      if (+betAmount !== +b) {
        const sets = Object.values(userSettings);
        const auto = Object.values(autoConfigs);
        const str = sets.concat(auto, b);
        const j = str.join(";");
        const settings = MessageFactory.createMessage(
          Protocol.USER_SETTINGS,
          j,
        );
        Globals.WS.sendMessage(settings);
      }

      this.handlePlay(b);
    } else {
      this.handleNotification("Not enough balance");
    }
  };
  handlePlay = (bet) => {
    this.handleIsClickable(false);
    this.handleShowText(false);
    Globals.WS.sendMessage(MessageFactory.createMessage(Protocol.BET, +bet));
  };
  toggleIsAutoOn = (e) => {
    this.setState({ isAutoOn: e });
    if (!e) {
      clearTimeout(this.myTimeout);
      this.setState({ isClickable: true });
    }
  };
  handleNotification = (n) => {
    if (!!n) {
      this.setState({ notification: n });
      clearTimeout(this.notificationTimeOut);
      this.notificationTimeOut = setTimeout(() => {
        this.setState({ notificationfadeOut: true });
        setTimeout(() => {
          this.setState({ notification: false, notificationfadeOut: false });
        }, 333);
      }, 1666);
    }
  };
  handleIsClickable = (c) => this.setState({ isClickable: c });
  handleShowText = (s) => this.setState({ showText: s });

  handleIsFast = (f) => {
    this.clearBetInfo();
    this.setState({ isFast: f });
  };

  clearBetInfo = () => {
    let betinfo = { ...this.state.betInfo };
    betinfo = {
      ...betinfo,
      dealer: ["0", "0", "0", "0", "0"],
      winTypeDealer: null,
      winPositionsDealer: [],
      player: ["0", "0", "0", "0", "0"],
      winTypePlayer: null,
      winPositionsPlayer: [],
    };
    this.setState({
      betInfo: betinfo,
    });
  };
  handleVerifyBet = (id) => {
    Globals.WS.sendMessage(
      MessageFactory.createMessage(Protocol.GET_ROUND, id),
    );
  };
  reconnect = () => {
    this.clearBetInfo();
    Globals.WS.Start();
  };

  render() {
    const {
      bet,
      isFast,
      betInfo,
      isAutoOn,
      isClickable,
      autoConfigs,
      userSettings,
      myHistory,
      allHistory,
      highRoller,
      provablyFairSeeds,
      notifyMSG,
      showText,
      notification,
      notificationfadeOut,
      toFix,
      currency,
      minBet,
      maxBet,
      noSignal,
      errorBtn,
      errorMsg,
      reload,
      betReplay,
      user_id,
    } = this.state;
    return (
      <AppContainer
        className="AppContainer"
        onContextMenu={(e) => e.preventDefault()}
      >
        {!!noSignal ? (
          <NoSignal
            // reconnect={this.reconnect}
            Globals={Globals}
            errorMsg={errorMsg}
            errorBtn={errorBtn}
            reload={reload}
            userSettings={userSettings}
          />
        ) : (
          <>
            <Spheres
              bet={bet}
              betInfo={betInfo}
              isClickable={isClickable}
              handleIsClickable={this.handleIsClickable}
              isAutoOn={isAutoOn}
              toggleIsAutoOn={this.toggleIsAutoOn}
              isFast={isFast}
              handleIsFast={this.handleIsFast}
              Globals={Globals}
              userSettings={userSettings}
              saveUserSettings={this.saveUserSettings}
              saveBetAndPlay={this.saveBetAndPlay}
              history={{ myHistory, allHistory, highRoller }}
              provablyFair={provablyFairSeeds}
              notifyMSG={notifyMSG}
              handleNotification={this.handleNotification}
              autoConfigs={autoConfigs}
              handleAutoRollLogic={this.handleAutoRollLogic}
              handleBetAmount={this.handleBetAmount}
              autorollLogic={this.autorollLogic}
              showText={showText}
              handleShowText={this.handleShowText}
              toFix={toFix}
              currency={currency}
              minBet={minBet}
              maxBet={maxBet}
              handleVerifyBet={this.handleVerifyBet}
              betReplay={betReplay}
              handleBetReply={this.handleBetReply}
              user_id={user_id}
            />
            {!!notification && (
              <Notification
                notifyText={notification}
                fadeOut={notificationfadeOut}
                handleNotification={this.handleNotification}
                userSettings={userSettings}
              />
            )}
          </>
        )}
      </AppContainer>
    );
  }
}

export default App;
